import { Tabs } from "antd";

import { MetadataDashboardTemplate } from "@/components/Templates/MetadataDashboardTemplate";
import PageHeader from "@/components/UI/PageHeader";

const OPERATIONS_CONSTANTS = {
  wikiLink: "/wiki/guides/exploration-measures-imagingoperations",
  idLink: undefined,
};

export default function ImagingOperations() {
  const items = [
    {
      key: "read-allocations",
      label: "Read Allocations",
      children: (
        <MetadataDashboardTemplate
          type="imaging_read_allocations"
          constants={OPERATIONS_CONSTANTS}
        />
      ),
    },
    {
      key: "esignatures",
      label: "eSignatures",
      children: (
        <MetadataDashboardTemplate
          type="esignatures"
          constants={OPERATIONS_CONSTANTS}
          selectionIdentifierColumn="entity_id"
        />
      ),
    },
    {
      key: "documents",
      label: "Documents",
      children: (
        <MetadataDashboardTemplate
          type="imaging_documents"
          constants={OPERATIONS_CONSTANTS}
        />
      ),
    },
    {
      key: "tat-tracking",
      label: "TAT Tracking",
      children: (
        <MetadataDashboardTemplate
          type="imaging_tat"
          constants={OPERATIONS_CONSTANTS}
        />
      ),
    },
  ];

  return (
    <div className="w-full p-4">
      <div className="flex justify-between mb-4 relative z-20">
        <div className="flex gap-2">
          <PageHeader
            title="Measures: Imaging Operations"
            tooltipText="Operational imaging workflow data: reader allocations, eSignatures, document submissions, and turnaround-time tracking."
          />
        </div>
      </div>
      <Tabs destroyOnHidden items={items} />
    </div>
  );
}
